/**
 * assets/partner-nearby.js
 * Gedrag van sections/partner-nearby.liquid
 *
 * Geknipt uit de inline <script> van dat bestand op 2026-08-15, 1:1.
 * Data komt uit dat bestand, gedrag staat hier. Zie ARCHITECTURE.md sectie 11.
 */

(function(){
  var btn=document.getElementById('pn-locate'), status=document.getElementById('pn-status'),
      list=document.getElementById('pn-list'), cards=[].slice.call(document.querySelectorAll('.pn-card')), none=document.getElementById('pn-none');
  function hav(a,b,c,d){var R=6371,p=Math.PI/180,x=(c-a)*p,y=(d-b)*p,s=Math.sin(x/2)*Math.sin(x/2)+Math.cos(a*p)*Math.cos(c*p)*Math.sin(y/2)*Math.sin(y/2);return R*2*Math.atan2(Math.sqrt(s),Math.sqrt(1-s));}
  if(!btn) return;
  btn.addEventListener('click', function(){
    if(!navigator.geolocation){ status.textContent='Je browser ondersteunt locatie niet.'; return; }
    status.textContent='Locatie ophalen...';
    navigator.geolocation.getCurrentPosition(function(pos){
      var la=pos.coords.latitude, lo=pos.coords.longitude, within=0;
      cards.forEach(function(c){
        var plat=parseFloat(c.getAttribute('data-lat')), plng=parseFloat(c.getAttribute('data-lng'));
        var badge=c.querySelector('.pn-distance');
        if(!isNaN(plat)&&!isNaN(plng)){ var d=Math.round(hav(la,lo,plat,plng)); c.dataset.dist=d;
          if(badge){ badge.textContent=d+' km'; badge.classList.remove('hidden'); }
          if(d<=50) within++;
        } else { c.dataset.dist=99999; }
      });
      cards.sort(function(a,b){ return (a.dataset.dist||99999)-(b.dataset.dist||99999); }).forEach(function(c){ list.appendChild(c); });
      status.textContent = within>0 ? ('Gesorteerd op afstand, '+within+' partner(s) binnen 50 km.') : 'Gesorteerd op afstand.';
      if(none) none.classList.toggle('hidden', within>0);
    }, function(){ status.textContent='Geen toestemming voor locatie. We tonen alle partners.'; }, {enableHighAccuracy:false,timeout:8000,maximumAge:600000});
  });
})();
